module.exports = __webpack_public_path__ + "static/media/nuevo-proyecto.6aed1cca.JPG";